<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="loading" [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div>
          <mat-form-field>
            <mat-label>Description</mat-label>
            <input matInput placeholder="" type="text" required formControlName="name" />
            <mat-error>
              <span *ngIf="f('name').hasError('required')">Veuillez saisir une description</span>
              <span *ngIf="f('name').hasError('maxlength')">La description ne doit pas dépasser 50 caractères</span>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</ng-template>
